<template>
    <header class="header" :class="{'isMobileClass':!isFoxtip || fullWidth<=900,'schoolClass':types == 'school'}" ref="navBars" v-resize="resizeHandle">
        <div v-if="types == 'school'" class="backBtn" @click="goBack"><i class="iconfont icon-zhankai-copy"></i><span>返回</span></div>
       <div class="headerCommonInner headerBox" v-if="types == 'school'">
          <div class="headerLeft" style="padding-left: 60px;">
            <div class="logoBox logo1">
                <img :src="schoolInfo.logo" alt="">
                <p>{{ schoolInfo.stitle }}</p>
            </div>
		  </div>
          <div class="headerRight">
            <div class="loginBox">
                <el-dropdown
                    v-if="$store.state.user_name!=null && this.$store.state.utoken"
                    :trigger="isHover"
                    placement="bottom"
                    class="unameDrop"
                    @visible-change="dropChange">
                    <span class="el-dropdown-link ">
                        <div class="avatarW" @click="" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                            <el-avatar v-if="!$store.state.headimgurl">{{ $store.state.user_name | usernameF }}</el-avatar>
                            <el-avatar v-if="$store.state.headimgurl" :src="$store.state.headimgurl"></el-avatar>
                        </div>
                    </span>
                    <el-dropdown-menu
                    slot="dropdown"
                    class=" personCenterMenu">
                        <el-dropdown-item  @click.native="goAipreparer" v-if="$store.state.utype == 2"><i class="iconfont icon-yijianbeifen"></i>备课中心</el-dropdown-item>
                        <el-dropdown-item  @click.native="goPage('/index/classManagement')" v-if="$store.state.utype == 2" ><i class="iconfont icon-jiarudaohang"></i>授课中心</el-dropdown-item>
                        <el-dropdown-item  @click.native="goPage('/index/capabilityAssessment')" v-if="1==2 && $store.state.utype == 2"><i class="iconfont icon-jiarudaohang"></i>能力评估</el-dropdown-item>
                        <el-dropdown-item @click.native="goPage('/index/classList')"><i class="iconfont icon-zhuanjiajigou"></i>学习中心</el-dropdown-item>
                        <el-dropdown-item  @click.native="goAdmin" divided v-if="$store.state.utype == 2 && $store.state.admin_url"><i class="iconfont icon-jianzhu02-L"></i>管理端</el-dropdown-item>
                        <el-dropdown-item @click.native="toPerson"  v-if="$store.state.utype == 2 && $store.state.admin_url"   ><i class="iconfont icon-wode"></i>{{ $t("Personal center") }}</el-dropdown-item>
                        <el-dropdown-item @click.native="toPerson"  v-if="!($store.state.utype == 2 && $store.state.admin_url)"   divided  ><i class="iconfont icon-wode"></i>{{ $t("Personal center") }}</el-dropdown-item>
                        <el-dropdown-item class="loginOutClass" @click.native="loginOut"><i class="iconfont icon-tuichu"></i>{{ $t("Sign out") }}</el-dropdown-item></el-dropdown-menu>
                </el-dropdown>
                <div class="loginBtn" v-if="!this.$store.state.utoken" v-show="$route.name != 'login'" @click="loginHandle">登录 | 注册</div>
            </div>
          </div>
          <div class="navBarMobile" v-if="!isFoxtip || fullWidth<=900">
                <!-- <div class="navBarMobile_l">
                </div> -->
                <div class="navBarMobile_c" style="margin-left: 40px;">
                    <div class="navName"  >
                        <img :src="schoolInfo.logo" alt="">
                        <p>{{ schoolInfo.stitle }}</p>
                    </div>
                </div>
                <div class="navBarMobile_r">
                    <div class="avatarW" @click="toPerson" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                        <el-avatar v-if="!$store.state.headimgurl">{{  $store.state.user_name | usernameF }}</el-avatar>
                        <el-avatar v-if="$store.state.headimgurl" :src="$store.state.headimgurl"></el-avatar>
                    </div>
                    <div v-if="!this.$store.state.utoken" v-show="$route.name != 'login'" class="logoText" @click="loginHandle">登录 | 注册</div>
                </div>
            </div>
       </div>
       <div class="headerCommonInner headerBox" v-else>
          <div class="headerLeft">
            <div class="logoBox"   @click="goHome"><img :src="require('../../../../static/img/logo.png')" alt=""></div>
			<div class="navList">
              <ul>
                <li v-for="(item,index) in navList" :key="index" :class="{'active':navInd == item.id}">
                    <el-dropdown v-if="item.mode==='dropdown'" placement="bottom">
                        <p class="sub-title" :class="{'active':navInd == item.id}">
                            {{ item.title }}
                        </p>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item class="sub-menu" v-for="subItem in item.children" :key="subItem.url">
                                <p class="sub-menu-item" :class="{'active':navSubId===subItem.subId}" @click="navHandle2(subItem)">{{ subItem.title }}</p>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <p v-else @click="navHandle(item,index)">{{item.title}}</p>
                </li>
              </ul>
            </div>
		  </div>
          <div class="headerRight">
            <div class="toolBox">
                <div class="messageBox"  v-show="false" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                    <div class="numBox"><span>0</span></div>
                    <i class="iconfont icon-xiaoxi"></i>
                </div>
                <el-dropdown
                    v-if="false"
                    :trigger="isHover"
                    placement="bottom"
                    class="eldropClass eldropthemeClass">
                    <span class="el-dropdown-link">
                        <div class="themeIcon"><i class="iconfont icon-pifuzhuti-copy"></i></div>
                    </span>
                    <el-dropdown-menu
                    slot="dropdown"
                    class="select-poppers selectPoppers">
                    <el-dropdown-item @click.native="changeTheme('white')">{{$t("Light theme")}}</el-dropdown-item>
                    <el-dropdown-item @click.native="changeTheme('black')">{{$t("Dark theme")}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="loginBox">
                <el-dropdown
                    v-if="$store.state.user_name!=null && this.$store.state.utoken"
                    :trigger="isHover"
                    placement="bottom"
                    class="unameDrop"
                    @visible-change="dropChange">
                    <span class="el-dropdown-link ">
                        <div class="avatarW" @click="" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                            <el-avatar v-if="!$store.state.headimgurl">{{ $store.state.user_name | usernameF }}</el-avatar>
                            <el-avatar v-if="$store.state.headimgurl" :src="$store.state.headimgurl"></el-avatar>
                        </div>
                        <!-- <div class="unameText">
                            <span>{{ $store.state.user_name }}</span>
                            <i class="el-icon-caret-bottom" :class="{ roteClass: arrowDown }"></i>
                        </div> -->
                    </span>
                    <el-dropdown-menu
                    slot="dropdown"
                    class=" personCenterMenu">
                        <el-dropdown-item @click.native="goAipreparer" v-if="$store.state.utype == 2"><i class="iconfont icon-yijianbeifen"></i>备课中心</el-dropdown-item>
                        <el-dropdown-item @click.native="goPage('/index/classManagement')" v-if="$store.state.utype == 2"><i class="iconfont icon-jiarudaohang"></i>授课中心</el-dropdown-item>
                        <el-dropdown-item @click.native="goPage('/index/classList')"><i class="iconfont icon-zhuanjiajigou"></i>学习中心</el-dropdown-item>
                        <el-dropdown-item @click.native="goPage('/index/capabilityAssessment')" v-if="1==2 && $store.state.utype == 2"><i class="iconfont icon-zhuanjiajigou"></i>能力评估</el-dropdown-item>
                        <el-dropdown-item @click.native="goAdmin" divided v-if="$store.state.utype == 2 && $store.state.admin_url"><i class="iconfont icon-jianzhu02-L"></i>管理端</el-dropdown-item>
                        <el-dropdown-item @click.native="toPerson"  v-if="$store.state.utype == 2 && $store.state.admin_url"><i class="iconfont icon-wode"></i>{{ $t("Personal center") }}</el-dropdown-item>
                        <el-dropdown-item @click.native="toPerson"  v-if="!($store.state.utype == 2 && $store.state.admin_url)"><i class="iconfont icon-wode"></i>{{ $t("Personal center") }}</el-dropdown-item>
                        <el-dropdown-item @click.native="openHelp()"><i class="iconfont icon-bangzhuzhongxin"></i>帮助手册</el-dropdown-item>
                        <el-dropdown-item @click.native="loginOut" class="loginOutClass"><i class="iconfont icon-tuichu"></i>{{ $t("Sign out") }}</el-dropdown-item></el-dropdown-menu>
                </el-dropdown>
                <div class="loginBtn" v-if="!this.$store.state.utoken" v-show="$route.name != 'login'" @click="loginHandle">登录 | 注册</div>
            </div>

          </div>
          <div class="navBarMobile" v-if="!isFoxtip || fullWidth<=900">
                <div class="navBarMobile_l">
                    <i class="iconfont icon-top-zhediedaohang" @click="openHeaderDrawer"></i>
                </div>
                <div class="navBarMobile_c">
                    <div class="navName"  @click="goHome"><img :src="require('../../../../static/img/logo.png')" alt=""></div>
                </div>
                <div class="navBarMobile_r">
                    <div class="avatarW" @click="toPerson" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                        <el-avatar v-if="!$store.state.headimgurl">{{  $store.state.user_name | usernameF }}</el-avatar>
                        <el-avatar v-if="$store.state.headimgurl" :src="$store.state.headimgurl"></el-avatar>
                    </div>
                    <div v-if="!this.$store.state.utoken" v-show="$route.name != 'login'" class="logoText" @click="loginHandle">登录 | 注册</div>
                </div>
            </div>
       </div>
       <el-drawer :title="''" custom-class="spaceDrawerClass" direction="ltr" :visible.sync="headerDrawer" :with-header="false" size="220px" append-to-body	>
            <div class="headerDrawerBox">
                <div class="itemLine" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                    <div class="personArea" @click="toPerson" >
                        <div class="avatarW" >
                        <el-avatar v-if="!$store.state.headimgurl">{{ $store.state.user_name | usernameF }}</el-avatar>
                        <el-avatar v-if="$store.state.headimgurl" :src="$store.state.headimgurl"></el-avatar>
                        </div>
                        <div class="personName"><p>{{ $store.state.user_name }}</p></div>
                    </div>
                </div>
                <div class="itemLine" v-if="!this.$store.state.utoken"  v-show="$route.name != 'login'">
                    <div  class="logoText" @click="loginHandle">登录 | 注册</div>
                </div>
                <div class="itemLine" >
                    <ul class="navList"  >
                        <li v-for="(item,index) in navList" :key="index">
                            <ul class="sub-nav-list" v-if="item.mode==='dropdown'">
                                <li class="sub-nav-title" :class="{'active':navInd===item.id}">{{ item.title }}</li>
                                <li class="sub-nav-item" v-for="subItem in item.children" :key="subItem.url" :class="{'active':navSubId===subItem.subId}"  @click="navHandle2(subItem)">{{ subItem.title }}</li>
                            </ul>
                            <div v-else class="oneLevel " :class="{'active':navInd == item.id}" @click="navHandle(item,index)">{{ item.title }}</div>
                        </li>
                    </ul>
                </div>
                <div class="itemLine" v-if="false">
                    <div class="toolBox">
                        <div class="toolBox_l">
                            <div class="themeIcon"><i class="iconfont icon-pifuzhuti-copy"></i></div>
                        </div>
                        <div class="toolBox_r">
                        <div class="themeColor">
                            <span>{{themeVal?$t("Dark theme"):'浅色'}}</span>
                            <el-switch v-model="themeVal" @change="changeTheme(themeVal?'black':'white')" size="small" >
                        </el-switch>
                        </div>

                        </div>
                    </div>
                </div>

                 <div class="itemLine"  v-if="$store.state.user_name!=null && this.$store.state.utoken && $store.state.utype == 2">
                    <div class="toolBox"  @click="goAipreparer">
                        <div class="toolBox_l"><i class="iconfont icon-yijianbeifen"></i></div>
                        <div class="toolBox_r">备课中心</div>
                    </div>
                </div>



                <div class="itemLine"  v-if="$store.state.user_name!=null && this.$store.state.utoken && $store.state.utype == 2">
                    <div class="toolBox"  @click="goPage('/index/classManagement')">
                        <div class="toolBox_l"><i class="iconfont icon-jiarudaohang"></i></div>
                        <div class="toolBox_r">授课中心</div>
                    </div>
                </div>
                <div class="itemLine"  v-if="$store.state.user_name!=null && this.$store.state.utoken">
                    <div class="toolBox" @click="goPage('/index/classList')">
                        <div class="toolBox_l"><i class="iconfont icon-zhuanjiajigou"></i></div>
                        <div class="toolBox_r">学习中心</div>
                    </div>
                </div>
                <div class="itemLine"  v-if="1==2 && $store.state.user_name!=null && this.$store.state.utoken && $store.state.utype == 2">
                    <div class="toolBox" @click="goPage('/index/capabilityAssessment')">
                        <div class="toolBox_l"><i class="iconfont icon-zhuanjiajigou"></i></div>
                        <div class="toolBox_r">能力评估</div>
                    </div>
                </div>

                <div class="itemLine"  v-if="$store.state.user_name!=null && this.$store.state.utoken && $store.state.utype == 2 && $store.state.admin_url">
                    <div class="toolBox"  @click="goAdmin">
                        <div class="toolBox_l"><i class="iconfont icon-jianzhu02-L"></i></div>
                        <div class="toolBox_r">管理端</div>
                    </div>
                </div>

                <div class="itemLine" >
                    <div class="toolBox" @click="openHelp()">
                        <div class="toolBox_l"><i class="iconfont icon-bangzhuzhongxin"></i></div>
                        <div class="toolBox_r">帮助手册</div>
                    </div>
                </div>
                <div class="itemLine" v-if="$store.state.user_name!=null && this.$store.state.utoken">
                    <div class="toolBox" @click="loginOut">
                        <div class="toolBox_l"><i class="iconfont icon-tuichu"></i ></div>
                        <div class="toolBox_r">{{ $t("Sign out") }}</div>
                    </div>
                </div>
            </div>
        </el-drawer>
     </header>
</template>
<script>
    import isMobile from '@/api/isMobile.js';
    import { setValue } from "@/api/setValue.js";
    import { getAjax, postAjax } from "@/api/index.js";
    export default{
        inject: ['reload'],
        props:{
            types:{},
            schoolInfo:{}
        },
        data(){
            return{
                navInd:0,
                navSubId:null,
                navList:[
                    {
                        title:"首页",
                        url:'/index/home',
                        id:0,
                    },
                    // {
                    //     title:'实训',
                    //     url:'/index/abilityList',
                    //     id:2,
                    // },
                    {
                        title:'课程&训练',
                        id:1,
                        mode:'dropdown',//表示下拉
                        children:[
                            {
                                title:'精品课程',
                                url:'/index/moreList/moreCourse',
                                subId:0
                            },
                            {
                                title:'实训训练营',
                                url:'/index/moreList/moreClass',
                                subId:1
                            },
                            {
                                title:'岗位训练营',
                                url:'/index/moreList/morePost',
                                subId:2
                            },
                        ]
                    },
                    {
                        title:'入驻机构',
                        url:'/index/organizationList',
                        id:3,
                    },
                    {
                        title:'交流社区',
                        url:'/index/exchangeList',
                        id:4,
                    },



                ],
                themeText:'',
                isHover:isMobile()?'click':'hover',
                arrowDown:false,
                themeVal:false,
                headerDrawer:false,
                isFoxtip: true,
                fullWidth: 1920,
            }
        },
        created(){
            this.initLang();
            this.initNav();
            this.getMyInfo();
        },
        mounted(){
            this.themeVal = window.document.documentElement.getAttribute("data-theme") == 'black' ? true : false;
            if (new RegExp("/Mobi|Mobi|Android|webOS|iPhone|iPod|BlackBerry/i").test(navigator.userAgent)) {
                this.isFoxtip = false
                } else {
                this.isFoxtip = true //pc
            }
        },
        methods:{
            goAdmin(){
                window.location.href = this.$store.state.admin_url;
                return;
            },
            openHelp(){
                window.open('/document/','_blank')
            },
            toPerson(){
                this.$router.push({
                    path:'/index/personal'
                })
                this.headerDrawer = false;
            },
            loginHandle(){
                this.$router.push({ path: "/login"});
                this.headerDrawer = false;
            },
            navHandle(item,index){
                this.navInd = item.id;
                this.navSubId = null;
                this.$router.push({
                    path:item.url
                });
                this.headerDrawer = false;
            },
            navHandle2(item){
                this.navInd = 1;
                this.navSubId = item.subId;
                this.$router.push({
                    path:item.url
                });
                this.headerDrawer = false;
            },
            initNav(){
                switch(this.$route.meta.navType) {
                    case "home":
                    this.navInd = 0;
                    break;
                    case "courseList":
                    this.navInd = 1;
                    const type=this.$route.params.type;
                    this.navSubId = type==='moreCourse'?0:type==='moreClass'?1:2
                    break;
                    case "program":
                    // this.navInd = 3;
                    this.navInd = 0;
                    break;
                    case 'abilityList':
                        this.navInd=2;
                    break;
                    break;
                    case 'organization':
                        this.navInd=3;
                    break;
                    case 'exchange':
                    this.navInd=4;
                    break;
                    case '101Test':
                    // this.navInd=5;
                    this.navInd = 0;
                    break;
                    case 'settled':
                    this.navInd=5;
                    break;
                    default:
                    this.navInd = 0;
                }
            },
            getMyInfo(){
                if(this.$route.name == 'login') return;
                let user_name = this.$store.state.user_name;
                if (user_name == null && window.localStorage.getItem('utoken')){
                    getAjax("/index/member/getMemberInfo").then((res)=> {
                        if (res.code ==1 ){
                            //用户已登录
                            // this.admin_url = res.data.automatic_logon_uri;
                            this.$store.commit('setUserName', res.data.uname);
                            this.$store.commit('setHeadimgurl', res.data.headimgurl);
                            this.$store.commit('setAdmin_url', res.data.automatic_logon_uri);
                            this.$store.commit('setBbs_status', res.data.bbs_status);
                            this.$store.commit('setReply_status', res.data.reply_status);
                            this.$store.commit('setUtype', res.data.utype);
                        }else{
                            //用户未登录 清除用户登录信息
                            this.$store.commit('setUserName', null);
                            this.$store.commit('setHeadimgurl', null);
                            this.$store.commit('setBbs_status', null);
                            this.$store.commit('setReply_status', null);
                            this.$store.commit('setAdmin_url', null);
                            this.$store.commit('setUtype', 1);
                            localStorageUtil.clearLoginStore();
                        }
                    });
                }
            },
            initLang(){
                this.langText = this.$i18n.locale=='en'?'English':'简体中文';
                this.themeText =  window.document.documentElement.getAttribute('data-theme')=='black'?this.$t('Dark theme'):this.$t('Light theme');
            },
            changeTheme(theme) {
                setValue("themeVal", theme);
                if (theme == "black") setValue("themeColor", "#f4a743");
                if (theme == "white") setValue("themeColor", "#1b9aee");
                window.localStorage.setItem("themeColor", theme);
                window.document.documentElement.setAttribute("data-theme", theme);
                this.reload();
                return
                postAjax("index/login/get_website_config").then(res=>{
                    this.homeTitle = res.website_name;
                    this.$store.commit('setlogoimgurl', window.document.documentElement.getAttribute('data-theme')=='black'?res.logo1:res.logo2);
                    window.localStorage.setItem('website_name',res.website_name)
                })
                this.reload();
            },
            loginOut() {
                this.$confirm(this.$t("person.log_out_body"), this.$t("Prompt"), {confirmButtonText: this.$t("OK"), cancelButtonText: this.$t("Cancel"), type: "warning",}).then(() => {
                    this.$store.commit('setUserName', null);
                    this.$store.commit('setHeadimgurl', null);
                    this.$store.commit('setBbs_status', null);
                    this.$store.commit('setReply_status', null);
                    this.$store.commit('setUtoken', null);
                    this.$store.commit('setAdmin_url', null);

                    let website_name = window.localStorage.getItem('website_name')
                    localStorage.removeItem("utoken", 0);
                    localStorage.removeItem("utype", 0);
                    localStorage.clear();
                    window.localStorage.setItem('website_name',website_name)
                    this.$router.push({ path: "/" });
                    this.headerDrawer = false;
                }).catch(() => {});
            },
            dropChange(val) {
                this.arrowDown = val;
            },

            goHome(){
                if(!(this.$route.path.toLowerCase().includes('/index/home'))){
                    this.$router.push({path:'/'})
                }
            },
            openHeaderDrawer(){
                this.headerDrawer = true;
            },
            resizeHandle(obj){
                this.fullWidth = parseInt(obj.width)
            },
            goPage(path){
                this.$router.push({
                    path:`${path}`
                });
                this.headerDrawer = false;
            },
            goBack(){
                this.$router.go(-1);
            },
            goAipreparer(){
                var origin = location.origin;
                if (origin.endsWith('/')) {
                    origin = origin.slice(0, -1);
                }
                window.open(`${origin}/aiPreparer/`,"_self");
            }
        },
        watch: {
            $route(to, from) {
                // var pages = this.$refs.pages.scrollTop = 0;
                switch(to.meta.navType) {
                    case "home":
                    this.navInd = 0;
                    break;
                    case "courseList":
                    this.navInd = 1;
                    const type=this.$route.params.type;
                    this.navSubId = type==='moreCourse'?0:type==='moreClass'?1:2
                    break;
                    case "program":
                    // this.navInd = 3;
                    this.navInd = 0;
                    break;
                    case 'abilityList':
                    this.navInd=2;
                    break;
                    case 'organization':
                    this.navInd=3;
                    break;
                    case 'exchange':
                    this.navInd=4;
                    break;
                    case '101Test':
                    // this.navInd=5;
                    this.navInd = 0;
                    break;
                    case 'settled':
                    this.navInd=5;
                    break;
                    default:
                    this.navInd = 0;
                }
            },
        },
        filters: {
            usernameF(val) {
                return val ? val.substring(val.length - 2) : val;
            }
        },
    }
</script>
<style lang="scss" scoped>
    @import "~@/assets/css/homepage/index/headerBar_code.scss";
    body .personCenterMenu.el-dropdown-menu .el-dropdown-menu__item{
        font-size:12px;
        @include font_color("font_color3");
        i{
            font-size:14px;
        }
        &.loginOutClass{
            color: #f56d5f !important;
        }
        &.el-dropdown-menu__item--divided{
            border-top: none;
            &::before{
                margin: 0;
               position: relative;
               top: -3px;
                width: 100%;
                border-top: 1px solid rgba(0,0,0,0.1);
                background-color: transparent;
            }
        }
        // .dividedClass{
        //     background-color: red;
        // }
    }
    .sub-menu{
        &:hover{
            background-color: white;
        }
        .sub-menu-item{
            cursor: pointer;
            padding: 5px 0;
            &:hover{
                color: #f1882b;
            }
            &.active{
                color: #f1882b;
            }
        }
    }
    .navList{
        .sub-title{
            color: #353535;
            font-size: var(--fontSize18px);
        }
        .active{
            color: #f1882b;
        }
        .sub-nav-list{
            border-bottom: 1px solid #f1f1f1;
            .sub-nav-item{
                padding-left: 10px;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                color: #666;
                &:hover{
                    color: #f1882b;
                }
                &.active{
                    color: #f1882b;
                }
            }
            .sub-nav-title{
                &:hover{
                    color: #f1882b;
                }
                &.active{
                    color: #f1882b;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/Common/Header/headerBar_code.vue